"use strict";

import $ from "jquery";
import Select2 from "Select2";

class SearchLookup
{
    constructor(lookups, options = false) {
        this.lookups = $(lookups);

        // Required.
        if (this.lookups.length < 1) {
            return;
        }

        this.lookups.each((index, select) => {
            const $select = $(select);

            const minInputLength = $select.data("search-input-length") || 0;
            const maxSelectionLength = $select.data("search-selection-length") || 0;
            const placeholder = $select.data("search-placeholder") || "";

            $select.select2(options || {
                allowClear: true,
                dropdownParent: $("#tours-content-container"),
                language: {
                    inputTooShort: () => { return ""; }
                },
                minimumInputLength: minInputLength,
                maximumSelectionLength: maxSelectionLength,
                placeholder: placeholder,
                templateSelection: (state) => {
                    return $(`<span class="select2-selection__choice__tag">${state.text}</span>`)
                },
                width: "100%"
            }).focus((event) => {
                $(event.target).select2("open");
            });

            this.listen($select);
        });
    }

    listen($select) {
        if ($select.select2("data").length > 0) {
            $($select.data("search-icon")).hide();
        }

        $select.on("select2:select", () => {
            this.dismissBlurEvents($select);
            $($select.data("search-icon")).hide();
        });

        $select.on("select2:close", () => {
            // show the icon if we have zero items selected
            if ($select.select2("data").length < 1) {
                $($select.data("search-icon")).show();
            }
        });
    }

    dismissBlurEvents($elem) {
        document.activeElement.blur();
        $elem.blur();
    }
}

export default SearchLookup;
